import React from 'react';
import { AppBar, Box, Toolbar, Typography, Menu, Container, Button, MenuItem, IconButton, Collapse } from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const pages = [];

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [showTooltip, setShowTooltip] = React.useState(false);

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'Rubik, sans-serif',
              fontWeight: 300,
              letterSpacing: '.05rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Karjääripäev | Karjääriredel viib kosmosesse
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography sx={{ textAlign: 'center' }}>{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Karjääripäev
          </Typography>
          <Box sx={{ position: 'absolute', top: '10%', right: '1%', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              {pages.map((page) => (
                <Button
                  key={page}
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'white', display: 'block' }}
                >
                  {page}
                </Button>
              ))}
            </Box>
            <Collapse in={showTooltip} orientation='horizontal'>
              <Typography>
                <a href='mailto:esero@ut.ee' style={{ textDecoration: 'none', color: 'white', backgroundColor: '#1976d2', padding: '10%', borderRadius: '5%', }}>
                  esero@ut.ee
                </a>
              </Typography>
            </Collapse>
            <IconButton aria-label="info" href='' size='large' onClick={() => { setShowTooltip(!showTooltip) }}>
              <InfoOutlineIcon sx={{ color: 'white' }} />
              <Typography color='white' paddingLeft={1}>
                Abi
              </Typography>
            </IconButton>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;